import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import Highcharts from 'highcharts';
import * as React from 'react';
import { Chart as HighChart, HighchartsChart, Tooltip, withHighcharts, XAxis, YAxis, PlotLine } from 'react-jsx-highcharts';
import { ChartNotAvailable } from './ChartNotAvailable';
import ChartLegend from './Legend';

var Chart =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Chart, _React$Component);

  function Chart(props) {
    _classCallCheck(this, Chart);

    return _possibleConstructorReturn(this, _getPrototypeOf(Chart).call(this, props));
  }

  _createClass(Chart, [{
    key: "render",
    value: function render() {
      var chartProps = this.props.chart ? Object.assign({
        chart: this.props.chart
      }) : null;
      return this.props.data.size > 0 ? React.createElement(HighchartsChart, Object.assign({
        plotOptions: Object.assign({}, this.props.plotOptions)
      }, chartProps), React.createElement(HighChart, null), this.props.showLegend && React.createElement(ChartLegend, {
        layout: "vertical",
        align: "right",
        verticalAlign: "middle"
      }), this.props.showToolTip && React.createElement(Tooltip, Object.assign({}, this.props.tooltipOptions)), React.createElement(XAxis, Object.assign({
        categories: this.props.xCategories,
        visible: this.props.xVisible
      }, this.props.xAxisOptions), this.props.xAxisTitle && React.createElement(XAxis.Title, null, this.props.xAxisTitle), this.props.xPlotLines && this.props.xPlotLines.map(function (_a) {
        var label = _a.label,
            plotLine = __rest(_a, ["label"]);

        return React.createElement(PlotLine, Object.assign({
          key: plotLine.id,
          dashStyle: "dash",
          width: 1,
          color: "#666"
        }, plotLine), React.createElement(PlotLine.Label, null, label));
      })), React.createElement(YAxis, Object.assign({
        visible: this.props.yVisible
      }, this.props.yAxisOptions), this.props.yAxisTitle && React.createElement(YAxis.Title, null, this.props.yAxisTitle), this.props.renderer(this.props.data))) : React.createElement(ChartNotAvailable, null);
    }
  }]);

  return Chart;
}(React.Component);

export default withHighcharts(Chart, Highcharts);